// source: gameapp.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.gameapp.ActivityInvoke', null, global);
goog.exportSymbol('proto.gameapp.AudioListenRequest', null, global);
goog.exportSymbol('proto.gameapp.AudioListenResponse', null, global);
goog.exportSymbol('proto.gameapp.Empty', null, global);
goog.exportSymbol('proto.gameapp.Event', null, global);
goog.exportSymbol('proto.gameapp.Exercise', null, global);
goog.exportSymbol('proto.gameapp.ExerciseSet', null, global);
goog.exportSymbol('proto.gameapp.ExerciseSetReport', null, global);
goog.exportSymbol('proto.gameapp.ImageEvaluateRequest', null, global);
goog.exportSymbol('proto.gameapp.ImageEvaluateResponse', null, global);
goog.exportSymbol('proto.gameapp.NamedMsgVals', null, global);
goog.exportSymbol('proto.gameapp.NamedVals', null, global);
goog.exportSymbol('proto.gameapp.NamedVals.NamedJsNtvParameter', null, global);
goog.exportSymbol('proto.gameapp.SessionData', null, global);
goog.exportSymbol('proto.gameapp.StateUpdateAS', null, global);
goog.exportSymbol('proto.gameapp.Status', null, global);
goog.exportSymbol('proto.gameapp.ToGameAppClient', null, global);
goog.exportSymbol('proto.gameapp.ToGameAppClient.TypeCase', null, global);
goog.exportSymbol('proto.gameapp.ToGameAppServer', null, global);
goog.exportSymbol('proto.gameapp.ToGameAppServer.ContentCase', null, global);
goog.exportSymbol('proto.gameapp.ValUnion', null, global);
goog.exportSymbol('proto.gameapp.ValUnion.ValCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.ToGameAppServer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.gameapp.ToGameAppServer.oneofGroups_);
};
goog.inherits(proto.gameapp.ToGameAppServer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.ToGameAppServer.displayName = 'proto.gameapp.ToGameAppServer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.ToGameAppClient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.gameapp.ToGameAppClient.oneofGroups_);
};
goog.inherits(proto.gameapp.ToGameAppClient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.ToGameAppClient.displayName = 'proto.gameapp.ToGameAppClient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.ValUnion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.gameapp.ValUnion.oneofGroups_);
};
goog.inherits(proto.gameapp.ValUnion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.ValUnion.displayName = 'proto.gameapp.ValUnion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.NamedMsgVals = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gameapp.NamedMsgVals.repeatedFields_, null);
};
goog.inherits(proto.gameapp.NamedMsgVals, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.NamedMsgVals.displayName = 'proto.gameapp.NamedMsgVals';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.NamedVals = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gameapp.NamedVals.repeatedFields_, null);
};
goog.inherits(proto.gameapp.NamedVals, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.NamedVals.displayName = 'proto.gameapp.NamedVals';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.NamedVals.NamedJsNtvParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.NamedVals.NamedJsNtvParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.NamedVals.NamedJsNtvParameter.displayName = 'proto.gameapp.NamedVals.NamedJsNtvParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.StateUpdateAS = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gameapp.StateUpdateAS.repeatedFields_, null);
};
goog.inherits(proto.gameapp.StateUpdateAS, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.StateUpdateAS.displayName = 'proto.gameapp.StateUpdateAS';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.Empty.displayName = 'proto.gameapp.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.Event.displayName = 'proto.gameapp.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.ExerciseSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.ExerciseSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.ExerciseSet.displayName = 'proto.gameapp.ExerciseSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.Exercise = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gameapp.Exercise.repeatedFields_, null);
};
goog.inherits(proto.gameapp.Exercise, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.Exercise.displayName = 'proto.gameapp.Exercise';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.SessionData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gameapp.SessionData.repeatedFields_, null);
};
goog.inherits(proto.gameapp.SessionData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.SessionData.displayName = 'proto.gameapp.SessionData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.ExerciseSetReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.ExerciseSetReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.ExerciseSetReport.displayName = 'proto.gameapp.ExerciseSetReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.AudioListenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.AudioListenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.AudioListenRequest.displayName = 'proto.gameapp.AudioListenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.AudioListenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.AudioListenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.AudioListenResponse.displayName = 'proto.gameapp.AudioListenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.ImageEvaluateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.ImageEvaluateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.ImageEvaluateRequest.displayName = 'proto.gameapp.ImageEvaluateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.ImageEvaluateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.ImageEvaluateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.ImageEvaluateResponse.displayName = 'proto.gameapp.ImageEvaluateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameapp.ActivityInvoke = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameapp.ActivityInvoke, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameapp.ActivityInvoke.displayName = 'proto.gameapp.ActivityInvoke';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.gameapp.ToGameAppServer.oneofGroups_ = [[1,2,3,4,5,6,7]];

/**
 * @enum {number}
 */
proto.gameapp.ToGameAppServer.ContentCase = {
  CONTENT_NOT_SET: 0,
  CPSH_NAMED_MSG_VALS: 1,
  CPSH_NAMED_VALS: 2,
  EXERCISE_SET_REPORT: 3,
  SET_STARTED: 4,
  SET_COMPLETED: 5,
  AUDIO_LISTEN_REQ: 6,
  IMAGE_EVAL_REQ: 7
};

/**
 * @return {proto.gameapp.ToGameAppServer.ContentCase}
 */
proto.gameapp.ToGameAppServer.prototype.getContentCase = function() {
  return /** @type {proto.gameapp.ToGameAppServer.ContentCase} */(jspb.Message.computeOneofCase(this, proto.gameapp.ToGameAppServer.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.ToGameAppServer.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.ToGameAppServer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.ToGameAppServer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ToGameAppServer.toObject = function(includeInstance, msg) {
  var f, obj = {
    cpshNamedMsgVals: (f = msg.getCpshNamedMsgVals()) && proto.gameapp.NamedMsgVals.toObject(includeInstance, f),
    cpshNamedVals: (f = msg.getCpshNamedVals()) && proto.gameapp.NamedVals.toObject(includeInstance, f),
    exerciseSetReport: (f = msg.getExerciseSetReport()) && proto.gameapp.ExerciseSetReport.toObject(includeInstance, f),
    setStarted: (f = msg.getSetStarted()) && proto.gameapp.Event.toObject(includeInstance, f),
    setCompleted: (f = msg.getSetCompleted()) && proto.gameapp.Event.toObject(includeInstance, f),
    audioListenReq: (f = msg.getAudioListenReq()) && proto.gameapp.AudioListenRequest.toObject(includeInstance, f),
    imageEvalReq: (f = msg.getImageEvalReq()) && proto.gameapp.ImageEvaluateRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.ToGameAppServer}
 */
proto.gameapp.ToGameAppServer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.ToGameAppServer;
  return proto.gameapp.ToGameAppServer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.ToGameAppServer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.ToGameAppServer}
 */
proto.gameapp.ToGameAppServer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameapp.NamedMsgVals;
      reader.readMessage(value,proto.gameapp.NamedMsgVals.deserializeBinaryFromReader);
      msg.setCpshNamedMsgVals(value);
      break;
    case 2:
      var value = new proto.gameapp.NamedVals;
      reader.readMessage(value,proto.gameapp.NamedVals.deserializeBinaryFromReader);
      msg.setCpshNamedVals(value);
      break;
    case 3:
      var value = new proto.gameapp.ExerciseSetReport;
      reader.readMessage(value,proto.gameapp.ExerciseSetReport.deserializeBinaryFromReader);
      msg.setExerciseSetReport(value);
      break;
    case 4:
      var value = new proto.gameapp.Event;
      reader.readMessage(value,proto.gameapp.Event.deserializeBinaryFromReader);
      msg.setSetStarted(value);
      break;
    case 5:
      var value = new proto.gameapp.Event;
      reader.readMessage(value,proto.gameapp.Event.deserializeBinaryFromReader);
      msg.setSetCompleted(value);
      break;
    case 6:
      var value = new proto.gameapp.AudioListenRequest;
      reader.readMessage(value,proto.gameapp.AudioListenRequest.deserializeBinaryFromReader);
      msg.setAudioListenReq(value);
      break;
    case 7:
      var value = new proto.gameapp.ImageEvaluateRequest;
      reader.readMessage(value,proto.gameapp.ImageEvaluateRequest.deserializeBinaryFromReader);
      msg.setImageEvalReq(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.ToGameAppServer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.ToGameAppServer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.ToGameAppServer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ToGameAppServer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCpshNamedMsgVals();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gameapp.NamedMsgVals.serializeBinaryToWriter
    );
  }
  f = message.getCpshNamedVals();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gameapp.NamedVals.serializeBinaryToWriter
    );
  }
  f = message.getExerciseSetReport();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.gameapp.ExerciseSetReport.serializeBinaryToWriter
    );
  }
  f = message.getSetStarted();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.gameapp.Event.serializeBinaryToWriter
    );
  }
  f = message.getSetCompleted();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.gameapp.Event.serializeBinaryToWriter
    );
  }
  f = message.getAudioListenReq();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.gameapp.AudioListenRequest.serializeBinaryToWriter
    );
  }
  f = message.getImageEvalReq();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.gameapp.ImageEvaluateRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional NamedMsgVals cpsh_named_msg_vals = 1;
 * @return {?proto.gameapp.NamedMsgVals}
 */
proto.gameapp.ToGameAppServer.prototype.getCpshNamedMsgVals = function() {
  return /** @type{?proto.gameapp.NamedMsgVals} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.NamedMsgVals, 1));
};


/**
 * @param {?proto.gameapp.NamedMsgVals|undefined} value
 * @return {!proto.gameapp.ToGameAppServer} returns this
*/
proto.gameapp.ToGameAppServer.prototype.setCpshNamedMsgVals = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.gameapp.ToGameAppServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppServer} returns this
 */
proto.gameapp.ToGameAppServer.prototype.clearCpshNamedMsgVals = function() {
  return this.setCpshNamedMsgVals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppServer.prototype.hasCpshNamedMsgVals = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NamedVals cpsh_named_vals = 2;
 * @return {?proto.gameapp.NamedVals}
 */
proto.gameapp.ToGameAppServer.prototype.getCpshNamedVals = function() {
  return /** @type{?proto.gameapp.NamedVals} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.NamedVals, 2));
};


/**
 * @param {?proto.gameapp.NamedVals|undefined} value
 * @return {!proto.gameapp.ToGameAppServer} returns this
*/
proto.gameapp.ToGameAppServer.prototype.setCpshNamedVals = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.gameapp.ToGameAppServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppServer} returns this
 */
proto.gameapp.ToGameAppServer.prototype.clearCpshNamedVals = function() {
  return this.setCpshNamedVals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppServer.prototype.hasCpshNamedVals = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ExerciseSetReport exercise_set_report = 3;
 * @return {?proto.gameapp.ExerciseSetReport}
 */
proto.gameapp.ToGameAppServer.prototype.getExerciseSetReport = function() {
  return /** @type{?proto.gameapp.ExerciseSetReport} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.ExerciseSetReport, 3));
};


/**
 * @param {?proto.gameapp.ExerciseSetReport|undefined} value
 * @return {!proto.gameapp.ToGameAppServer} returns this
*/
proto.gameapp.ToGameAppServer.prototype.setExerciseSetReport = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.gameapp.ToGameAppServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppServer} returns this
 */
proto.gameapp.ToGameAppServer.prototype.clearExerciseSetReport = function() {
  return this.setExerciseSetReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppServer.prototype.hasExerciseSetReport = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Event set_started = 4;
 * @return {?proto.gameapp.Event}
 */
proto.gameapp.ToGameAppServer.prototype.getSetStarted = function() {
  return /** @type{?proto.gameapp.Event} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.Event, 4));
};


/**
 * @param {?proto.gameapp.Event|undefined} value
 * @return {!proto.gameapp.ToGameAppServer} returns this
*/
proto.gameapp.ToGameAppServer.prototype.setSetStarted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.gameapp.ToGameAppServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppServer} returns this
 */
proto.gameapp.ToGameAppServer.prototype.clearSetStarted = function() {
  return this.setSetStarted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppServer.prototype.hasSetStarted = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Event set_completed = 5;
 * @return {?proto.gameapp.Event}
 */
proto.gameapp.ToGameAppServer.prototype.getSetCompleted = function() {
  return /** @type{?proto.gameapp.Event} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.Event, 5));
};


/**
 * @param {?proto.gameapp.Event|undefined} value
 * @return {!proto.gameapp.ToGameAppServer} returns this
*/
proto.gameapp.ToGameAppServer.prototype.setSetCompleted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.gameapp.ToGameAppServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppServer} returns this
 */
proto.gameapp.ToGameAppServer.prototype.clearSetCompleted = function() {
  return this.setSetCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppServer.prototype.hasSetCompleted = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional AudioListenRequest audio_listen_req = 6;
 * @return {?proto.gameapp.AudioListenRequest}
 */
proto.gameapp.ToGameAppServer.prototype.getAudioListenReq = function() {
  return /** @type{?proto.gameapp.AudioListenRequest} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.AudioListenRequest, 6));
};


/**
 * @param {?proto.gameapp.AudioListenRequest|undefined} value
 * @return {!proto.gameapp.ToGameAppServer} returns this
*/
proto.gameapp.ToGameAppServer.prototype.setAudioListenReq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.gameapp.ToGameAppServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppServer} returns this
 */
proto.gameapp.ToGameAppServer.prototype.clearAudioListenReq = function() {
  return this.setAudioListenReq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppServer.prototype.hasAudioListenReq = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ImageEvaluateRequest image_eval_req = 7;
 * @return {?proto.gameapp.ImageEvaluateRequest}
 */
proto.gameapp.ToGameAppServer.prototype.getImageEvalReq = function() {
  return /** @type{?proto.gameapp.ImageEvaluateRequest} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.ImageEvaluateRequest, 7));
};


/**
 * @param {?proto.gameapp.ImageEvaluateRequest|undefined} value
 * @return {!proto.gameapp.ToGameAppServer} returns this
*/
proto.gameapp.ToGameAppServer.prototype.setImageEvalReq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.gameapp.ToGameAppServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppServer} returns this
 */
proto.gameapp.ToGameAppServer.prototype.clearImageEvalReq = function() {
  return this.setImageEvalReq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppServer.prototype.hasImageEvalReq = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.gameapp.ToGameAppClient.oneofGroups_ = [[1,2,3,4,5,6,7,8,9,10,11]];

/**
 * @enum {number}
 */
proto.gameapp.ToGameAppClient.TypeCase = {
  TYPE_NOT_SET: 0,
  SPSH_NAMED_MSG_VALS: 1,
  SPSH_NAMED_VALS: 2,
  SESSION_DATA: 3,
  TASK_START: 4,
  TASK_COMPLETE: 5,
  EXERCISE_START: 6,
  SET_START: 7,
  AUDIO_LISTEN_RESP: 8,
  ACTIVITY_INVOKE: 9,
  IMAGE_EVAL_RESP: 10,
  STATE_UPDATE_AS: 11
};

/**
 * @return {proto.gameapp.ToGameAppClient.TypeCase}
 */
proto.gameapp.ToGameAppClient.prototype.getTypeCase = function() {
  return /** @type {proto.gameapp.ToGameAppClient.TypeCase} */(jspb.Message.computeOneofCase(this, proto.gameapp.ToGameAppClient.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.ToGameAppClient.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.ToGameAppClient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.ToGameAppClient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ToGameAppClient.toObject = function(includeInstance, msg) {
  var f, obj = {
    spshNamedMsgVals: (f = msg.getSpshNamedMsgVals()) && proto.gameapp.NamedMsgVals.toObject(includeInstance, f),
    spshNamedVals: (f = msg.getSpshNamedVals()) && proto.gameapp.NamedVals.toObject(includeInstance, f),
    sessionData: (f = msg.getSessionData()) && proto.gameapp.SessionData.toObject(includeInstance, f),
    taskStart: jspb.Message.getFieldWithDefault(msg, 4, ""),
    taskComplete: jspb.Message.getFieldWithDefault(msg, 5, ""),
    exerciseStart: jspb.Message.getFieldWithDefault(msg, 6, ""),
    setStart: jspb.Message.getFieldWithDefault(msg, 7, ""),
    audioListenResp: (f = msg.getAudioListenResp()) && proto.gameapp.AudioListenResponse.toObject(includeInstance, f),
    activityInvoke: (f = msg.getActivityInvoke()) && proto.gameapp.ActivityInvoke.toObject(includeInstance, f),
    imageEvalResp: (f = msg.getImageEvalResp()) && proto.gameapp.ImageEvaluateResponse.toObject(includeInstance, f),
    stateUpdateAs: (f = msg.getStateUpdateAs()) && proto.gameapp.StateUpdateAS.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.ToGameAppClient}
 */
proto.gameapp.ToGameAppClient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.ToGameAppClient;
  return proto.gameapp.ToGameAppClient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.ToGameAppClient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.ToGameAppClient}
 */
proto.gameapp.ToGameAppClient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameapp.NamedMsgVals;
      reader.readMessage(value,proto.gameapp.NamedMsgVals.deserializeBinaryFromReader);
      msg.setSpshNamedMsgVals(value);
      break;
    case 2:
      var value = new proto.gameapp.NamedVals;
      reader.readMessage(value,proto.gameapp.NamedVals.deserializeBinaryFromReader);
      msg.setSpshNamedVals(value);
      break;
    case 3:
      var value = new proto.gameapp.SessionData;
      reader.readMessage(value,proto.gameapp.SessionData.deserializeBinaryFromReader);
      msg.setSessionData(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskStart(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskComplete(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setExerciseStart(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSetStart(value);
      break;
    case 8:
      var value = new proto.gameapp.AudioListenResponse;
      reader.readMessage(value,proto.gameapp.AudioListenResponse.deserializeBinaryFromReader);
      msg.setAudioListenResp(value);
      break;
    case 9:
      var value = new proto.gameapp.ActivityInvoke;
      reader.readMessage(value,proto.gameapp.ActivityInvoke.deserializeBinaryFromReader);
      msg.setActivityInvoke(value);
      break;
    case 10:
      var value = new proto.gameapp.ImageEvaluateResponse;
      reader.readMessage(value,proto.gameapp.ImageEvaluateResponse.deserializeBinaryFromReader);
      msg.setImageEvalResp(value);
      break;
    case 11:
      var value = new proto.gameapp.StateUpdateAS;
      reader.readMessage(value,proto.gameapp.StateUpdateAS.deserializeBinaryFromReader);
      msg.setStateUpdateAs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.ToGameAppClient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.ToGameAppClient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.ToGameAppClient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ToGameAppClient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpshNamedMsgVals();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gameapp.NamedMsgVals.serializeBinaryToWriter
    );
  }
  f = message.getSpshNamedVals();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gameapp.NamedVals.serializeBinaryToWriter
    );
  }
  f = message.getSessionData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.gameapp.SessionData.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAudioListenResp();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.gameapp.AudioListenResponse.serializeBinaryToWriter
    );
  }
  f = message.getActivityInvoke();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.gameapp.ActivityInvoke.serializeBinaryToWriter
    );
  }
  f = message.getImageEvalResp();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.gameapp.ImageEvaluateResponse.serializeBinaryToWriter
    );
  }
  f = message.getStateUpdateAs();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.gameapp.StateUpdateAS.serializeBinaryToWriter
    );
  }
};


/**
 * optional NamedMsgVals spsh_named_msg_vals = 1;
 * @return {?proto.gameapp.NamedMsgVals}
 */
proto.gameapp.ToGameAppClient.prototype.getSpshNamedMsgVals = function() {
  return /** @type{?proto.gameapp.NamedMsgVals} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.NamedMsgVals, 1));
};


/**
 * @param {?proto.gameapp.NamedMsgVals|undefined} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
*/
proto.gameapp.ToGameAppClient.prototype.setSpshNamedMsgVals = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearSpshNamedMsgVals = function() {
  return this.setSpshNamedMsgVals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasSpshNamedMsgVals = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NamedVals spsh_named_vals = 2;
 * @return {?proto.gameapp.NamedVals}
 */
proto.gameapp.ToGameAppClient.prototype.getSpshNamedVals = function() {
  return /** @type{?proto.gameapp.NamedVals} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.NamedVals, 2));
};


/**
 * @param {?proto.gameapp.NamedVals|undefined} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
*/
proto.gameapp.ToGameAppClient.prototype.setSpshNamedVals = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearSpshNamedVals = function() {
  return this.setSpshNamedVals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasSpshNamedVals = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SessionData session_data = 3;
 * @return {?proto.gameapp.SessionData}
 */
proto.gameapp.ToGameAppClient.prototype.getSessionData = function() {
  return /** @type{?proto.gameapp.SessionData} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.SessionData, 3));
};


/**
 * @param {?proto.gameapp.SessionData|undefined} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
*/
proto.gameapp.ToGameAppClient.prototype.setSessionData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearSessionData = function() {
  return this.setSessionData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasSessionData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string task_start = 4;
 * @return {string}
 */
proto.gameapp.ToGameAppClient.prototype.getTaskStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.setTaskStart = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearTaskStart = function() {
  return jspb.Message.setOneofField(this, 4, proto.gameapp.ToGameAppClient.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasTaskStart = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string task_complete = 5;
 * @return {string}
 */
proto.gameapp.ToGameAppClient.prototype.getTaskComplete = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.setTaskComplete = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearTaskComplete = function() {
  return jspb.Message.setOneofField(this, 5, proto.gameapp.ToGameAppClient.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasTaskComplete = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string exercise_start = 6;
 * @return {string}
 */
proto.gameapp.ToGameAppClient.prototype.getExerciseStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.setExerciseStart = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearExerciseStart = function() {
  return jspb.Message.setOneofField(this, 6, proto.gameapp.ToGameAppClient.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasExerciseStart = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string set_start = 7;
 * @return {string}
 */
proto.gameapp.ToGameAppClient.prototype.getSetStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.setSetStart = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearSetStart = function() {
  return jspb.Message.setOneofField(this, 7, proto.gameapp.ToGameAppClient.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasSetStart = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional AudioListenResponse audio_listen_resp = 8;
 * @return {?proto.gameapp.AudioListenResponse}
 */
proto.gameapp.ToGameAppClient.prototype.getAudioListenResp = function() {
  return /** @type{?proto.gameapp.AudioListenResponse} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.AudioListenResponse, 8));
};


/**
 * @param {?proto.gameapp.AudioListenResponse|undefined} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
*/
proto.gameapp.ToGameAppClient.prototype.setAudioListenResp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearAudioListenResp = function() {
  return this.setAudioListenResp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasAudioListenResp = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ActivityInvoke activity_invoke = 9;
 * @return {?proto.gameapp.ActivityInvoke}
 */
proto.gameapp.ToGameAppClient.prototype.getActivityInvoke = function() {
  return /** @type{?proto.gameapp.ActivityInvoke} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.ActivityInvoke, 9));
};


/**
 * @param {?proto.gameapp.ActivityInvoke|undefined} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
*/
proto.gameapp.ToGameAppClient.prototype.setActivityInvoke = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearActivityInvoke = function() {
  return this.setActivityInvoke(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasActivityInvoke = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ImageEvaluateResponse image_eval_resp = 10;
 * @return {?proto.gameapp.ImageEvaluateResponse}
 */
proto.gameapp.ToGameAppClient.prototype.getImageEvalResp = function() {
  return /** @type{?proto.gameapp.ImageEvaluateResponse} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.ImageEvaluateResponse, 10));
};


/**
 * @param {?proto.gameapp.ImageEvaluateResponse|undefined} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
*/
proto.gameapp.ToGameAppClient.prototype.setImageEvalResp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearImageEvalResp = function() {
  return this.setImageEvalResp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasImageEvalResp = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional StateUpdateAS state_update_aS = 11;
 * @return {?proto.gameapp.StateUpdateAS}
 */
proto.gameapp.ToGameAppClient.prototype.getStateUpdateAs = function() {
  return /** @type{?proto.gameapp.StateUpdateAS} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.StateUpdateAS, 11));
};


/**
 * @param {?proto.gameapp.StateUpdateAS|undefined} value
 * @return {!proto.gameapp.ToGameAppClient} returns this
*/
proto.gameapp.ToGameAppClient.prototype.setStateUpdateAs = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.gameapp.ToGameAppClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ToGameAppClient} returns this
 */
proto.gameapp.ToGameAppClient.prototype.clearStateUpdateAs = function() {
  return this.setStateUpdateAs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ToGameAppClient.prototype.hasStateUpdateAs = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.gameapp.ValUnion.oneofGroups_ = [[1,2,3,4,5,6]];

/**
 * @enum {number}
 */
proto.gameapp.ValUnion.ValCase = {
  VAL_NOT_SET: 0,
  STR_VAL: 1,
  BIN_VAL: 2,
  NUM_VAL: 3,
  U32_VAL: 4,
  S32_VAL: 5,
  BOOL_VAL: 6
};

/**
 * @return {proto.gameapp.ValUnion.ValCase}
 */
proto.gameapp.ValUnion.prototype.getValCase = function() {
  return /** @type {proto.gameapp.ValUnion.ValCase} */(jspb.Message.computeOneofCase(this, proto.gameapp.ValUnion.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.ValUnion.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.ValUnion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.ValUnion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ValUnion.toObject = function(includeInstance, msg) {
  var f, obj = {
    strVal: jspb.Message.getFieldWithDefault(msg, 1, ""),
    binVal: msg.getBinVal_asB64(),
    numVal: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    u32Val: jspb.Message.getFieldWithDefault(msg, 4, 0),
    s32Val: jspb.Message.getFieldWithDefault(msg, 5, 0),
    boolVal: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.ValUnion}
 */
proto.gameapp.ValUnion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.ValUnion;
  return proto.gameapp.ValUnion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.ValUnion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.ValUnion}
 */
proto.gameapp.ValUnion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrVal(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBinVal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNumVal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setU32Val(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setS32Val(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoolVal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.ValUnion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.ValUnion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.ValUnion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ValUnion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeSint32(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string str_val = 1;
 * @return {string}
 */
proto.gameapp.ValUnion.prototype.getStrVal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.setStrVal = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.gameapp.ValUnion.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.clearStrVal = function() {
  return jspb.Message.setOneofField(this, 1, proto.gameapp.ValUnion.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ValUnion.prototype.hasStrVal = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes bin_val = 2;
 * @return {!(string|Uint8Array)}
 */
proto.gameapp.ValUnion.prototype.getBinVal = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes bin_val = 2;
 * This is a type-conversion wrapper around `getBinVal()`
 * @return {string}
 */
proto.gameapp.ValUnion.prototype.getBinVal_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBinVal()));
};


/**
 * optional bytes bin_val = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBinVal()`
 * @return {!Uint8Array}
 */
proto.gameapp.ValUnion.prototype.getBinVal_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBinVal()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.setBinVal = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.gameapp.ValUnion.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.clearBinVal = function() {
  return jspb.Message.setOneofField(this, 2, proto.gameapp.ValUnion.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ValUnion.prototype.hasBinVal = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double num_val = 3;
 * @return {number}
 */
proto.gameapp.ValUnion.prototype.getNumVal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.setNumVal = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.gameapp.ValUnion.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.clearNumVal = function() {
  return jspb.Message.setOneofField(this, 3, proto.gameapp.ValUnion.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ValUnion.prototype.hasNumVal = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 u32_val = 4;
 * @return {number}
 */
proto.gameapp.ValUnion.prototype.getU32Val = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.setU32Val = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.gameapp.ValUnion.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.clearU32Val = function() {
  return jspb.Message.setOneofField(this, 4, proto.gameapp.ValUnion.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ValUnion.prototype.hasU32Val = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional sint32 s32_val = 5;
 * @return {number}
 */
proto.gameapp.ValUnion.prototype.getS32Val = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.setS32Val = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.gameapp.ValUnion.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.clearS32Val = function() {
  return jspb.Message.setOneofField(this, 5, proto.gameapp.ValUnion.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ValUnion.prototype.hasS32Val = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool bool_val = 6;
 * @return {boolean}
 */
proto.gameapp.ValUnion.prototype.getBoolVal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.setBoolVal = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.gameapp.ValUnion.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.gameapp.ValUnion} returns this
 */
proto.gameapp.ValUnion.prototype.clearBoolVal = function() {
  return jspb.Message.setOneofField(this, 6, proto.gameapp.ValUnion.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ValUnion.prototype.hasBoolVal = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gameapp.NamedMsgVals.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.NamedMsgVals.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.NamedMsgVals.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.NamedMsgVals} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.NamedMsgVals.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valsList: jspb.Message.toObjectList(msg.getValsList(),
    proto.gameapp.ValUnion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.NamedMsgVals}
 */
proto.gameapp.NamedMsgVals.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.NamedMsgVals;
  return proto.gameapp.NamedMsgVals.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.NamedMsgVals} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.NamedMsgVals}
 */
proto.gameapp.NamedMsgVals.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.gameapp.ValUnion;
      reader.readMessage(value,proto.gameapp.ValUnion.deserializeBinaryFromReader);
      msg.addVals(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.NamedMsgVals.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.NamedMsgVals.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.NamedMsgVals} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.NamedMsgVals.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.gameapp.ValUnion.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.gameapp.NamedMsgVals.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.NamedMsgVals} returns this
 */
proto.gameapp.NamedMsgVals.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ValUnion vals = 2;
 * @return {!Array<!proto.gameapp.ValUnion>}
 */
proto.gameapp.NamedMsgVals.prototype.getValsList = function() {
  return /** @type{!Array<!proto.gameapp.ValUnion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gameapp.ValUnion, 2));
};


/**
 * @param {!Array<!proto.gameapp.ValUnion>} value
 * @return {!proto.gameapp.NamedMsgVals} returns this
*/
proto.gameapp.NamedMsgVals.prototype.setValsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.gameapp.ValUnion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gameapp.ValUnion}
 */
proto.gameapp.NamedMsgVals.prototype.addVals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.gameapp.ValUnion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameapp.NamedMsgVals} returns this
 */
proto.gameapp.NamedMsgVals.prototype.clearValsList = function() {
  return this.setValsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gameapp.NamedVals.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.NamedVals.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.NamedVals.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.NamedVals} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.NamedVals.toObject = function(includeInstance, msg) {
  var f, obj = {
    npList: jspb.Message.toObjectList(msg.getNpList(),
    proto.gameapp.NamedVals.NamedJsNtvParameter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.NamedVals}
 */
proto.gameapp.NamedVals.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.NamedVals;
  return proto.gameapp.NamedVals.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.NamedVals} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.NamedVals}
 */
proto.gameapp.NamedVals.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameapp.NamedVals.NamedJsNtvParameter;
      reader.readMessage(value,proto.gameapp.NamedVals.NamedJsNtvParameter.deserializeBinaryFromReader);
      msg.addNp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.NamedVals.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.NamedVals.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.NamedVals} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.NamedVals.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.gameapp.NamedVals.NamedJsNtvParameter.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.NamedVals.NamedJsNtvParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.NamedVals.NamedJsNtvParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    val: (f = msg.getVal()) && proto.gameapp.ValUnion.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.NamedVals.NamedJsNtvParameter}
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.NamedVals.NamedJsNtvParameter;
  return proto.gameapp.NamedVals.NamedJsNtvParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.NamedVals.NamedJsNtvParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.NamedVals.NamedJsNtvParameter}
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.gameapp.ValUnion;
      reader.readMessage(value,proto.gameapp.ValUnion.deserializeBinaryFromReader);
      msg.setVal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.NamedVals.NamedJsNtvParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.NamedVals.NamedJsNtvParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVal();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gameapp.ValUnion.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.NamedVals.NamedJsNtvParameter} returns this
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ValUnion val = 2;
 * @return {?proto.gameapp.ValUnion}
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.prototype.getVal = function() {
  return /** @type{?proto.gameapp.ValUnion} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.ValUnion, 2));
};


/**
 * @param {?proto.gameapp.ValUnion|undefined} value
 * @return {!proto.gameapp.NamedVals.NamedJsNtvParameter} returns this
*/
proto.gameapp.NamedVals.NamedJsNtvParameter.prototype.setVal = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.NamedVals.NamedJsNtvParameter} returns this
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.prototype.clearVal = function() {
  return this.setVal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.NamedVals.NamedJsNtvParameter.prototype.hasVal = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated NamedJsNtvParameter np = 1;
 * @return {!Array<!proto.gameapp.NamedVals.NamedJsNtvParameter>}
 */
proto.gameapp.NamedVals.prototype.getNpList = function() {
  return /** @type{!Array<!proto.gameapp.NamedVals.NamedJsNtvParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gameapp.NamedVals.NamedJsNtvParameter, 1));
};


/**
 * @param {!Array<!proto.gameapp.NamedVals.NamedJsNtvParameter>} value
 * @return {!proto.gameapp.NamedVals} returns this
*/
proto.gameapp.NamedVals.prototype.setNpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.gameapp.NamedVals.NamedJsNtvParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gameapp.NamedVals.NamedJsNtvParameter}
 */
proto.gameapp.NamedVals.prototype.addNp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.gameapp.NamedVals.NamedJsNtvParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameapp.NamedVals} returns this
 */
proto.gameapp.NamedVals.prototype.clearNpList = function() {
  return this.setNpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gameapp.StateUpdateAS.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.StateUpdateAS.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.StateUpdateAS.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.StateUpdateAS} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.StateUpdateAS.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.StateUpdateAS}
 */
proto.gameapp.StateUpdateAS.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.StateUpdateAS;
  return proto.gameapp.StateUpdateAS.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.StateUpdateAS} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.StateUpdateAS}
 */
proto.gameapp.StateUpdateAS.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.StateUpdateAS.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.StateUpdateAS.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.StateUpdateAS} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.StateUpdateAS.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.gameapp.StateUpdateAS.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.StateUpdateAS} returns this
 */
proto.gameapp.StateUpdateAS.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string values = 2;
 * @return {!Array<string>}
 */
proto.gameapp.StateUpdateAS.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.gameapp.StateUpdateAS} returns this
 */
proto.gameapp.StateUpdateAS.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.gameapp.StateUpdateAS} returns this
 */
proto.gameapp.StateUpdateAS.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameapp.StateUpdateAS} returns this
 */
proto.gameapp.StateUpdateAS.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.Empty}
 */
proto.gameapp.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.Empty;
  return proto.gameapp.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.Empty}
 */
proto.gameapp.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.Event.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.Event}
 */
proto.gameapp.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.Event;
  return proto.gameapp.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.Event}
 */
proto.gameapp.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string info = 1;
 * @return {string}
 */
proto.gameapp.Event.prototype.getInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.Event} returns this
 */
proto.gameapp.Event.prototype.setInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.ExerciseSet.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.ExerciseSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.ExerciseSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ExerciseSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    plannedReps: jspb.Message.getFieldWithDefault(msg, 1, 0),
    actualReps: jspb.Message.getFieldWithDefault(msg, 2, 0),
    restTimeSeconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.ExerciseSet}
 */
proto.gameapp.ExerciseSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.ExerciseSet;
  return proto.gameapp.ExerciseSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.ExerciseSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.ExerciseSet}
 */
proto.gameapp.ExerciseSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPlannedReps(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActualReps(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRestTimeSeconds(value);
      break;
    case 4:
      var value = /** @type {!proto.gameapp.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.ExerciseSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.ExerciseSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.ExerciseSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ExerciseSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlannedReps();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getActualReps();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRestTimeSeconds();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional uint32 planned_reps = 1;
 * @return {number}
 */
proto.gameapp.ExerciseSet.prototype.getPlannedReps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.ExerciseSet} returns this
 */
proto.gameapp.ExerciseSet.prototype.setPlannedReps = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 actual_reps = 2;
 * @return {number}
 */
proto.gameapp.ExerciseSet.prototype.getActualReps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.ExerciseSet} returns this
 */
proto.gameapp.ExerciseSet.prototype.setActualReps = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 rest_time_seconds = 3;
 * @return {number}
 */
proto.gameapp.ExerciseSet.prototype.getRestTimeSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.ExerciseSet} returns this
 */
proto.gameapp.ExerciseSet.prototype.setRestTimeSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Status status = 4;
 * @return {!proto.gameapp.Status}
 */
proto.gameapp.ExerciseSet.prototype.getStatus = function() {
  return /** @type {!proto.gameapp.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.gameapp.Status} value
 * @return {!proto.gameapp.ExerciseSet} returns this
 */
proto.gameapp.ExerciseSet.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gameapp.Exercise.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.Exercise.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.Exercise.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.Exercise} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.Exercise.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    setsList: jspb.Message.toObjectList(msg.getSetsList(),
    proto.gameapp.ExerciseSet.toObject, includeInstance),
    currentSetIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.Exercise}
 */
proto.gameapp.Exercise.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.Exercise;
  return proto.gameapp.Exercise.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.Exercise} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.Exercise}
 */
proto.gameapp.Exercise.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.gameapp.ExerciseSet;
      reader.readMessage(value,proto.gameapp.ExerciseSet.deserializeBinaryFromReader);
      msg.addSets(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCurrentSetIndex(value);
      break;
    case 4:
      var value = /** @type {!proto.gameapp.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.Exercise.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.Exercise.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.Exercise} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.Exercise.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.gameapp.ExerciseSet.serializeBinaryToWriter
    );
  }
  f = message.getCurrentSetIndex();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.gameapp.Exercise.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.Exercise} returns this
 */
proto.gameapp.Exercise.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ExerciseSet sets = 2;
 * @return {!Array<!proto.gameapp.ExerciseSet>}
 */
proto.gameapp.Exercise.prototype.getSetsList = function() {
  return /** @type{!Array<!proto.gameapp.ExerciseSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gameapp.ExerciseSet, 2));
};


/**
 * @param {!Array<!proto.gameapp.ExerciseSet>} value
 * @return {!proto.gameapp.Exercise} returns this
*/
proto.gameapp.Exercise.prototype.setSetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.gameapp.ExerciseSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gameapp.ExerciseSet}
 */
proto.gameapp.Exercise.prototype.addSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.gameapp.ExerciseSet, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameapp.Exercise} returns this
 */
proto.gameapp.Exercise.prototype.clearSetsList = function() {
  return this.setSetsList([]);
};


/**
 * optional uint32 current_set_index = 3;
 * @return {number}
 */
proto.gameapp.Exercise.prototype.getCurrentSetIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.Exercise} returns this
 */
proto.gameapp.Exercise.prototype.setCurrentSetIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Status status = 4;
 * @return {!proto.gameapp.Status}
 */
proto.gameapp.Exercise.prototype.getStatus = function() {
  return /** @type {!proto.gameapp.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.gameapp.Status} value
 * @return {!proto.gameapp.Exercise} returns this
 */
proto.gameapp.Exercise.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gameapp.SessionData.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.SessionData.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.SessionData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.SessionData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.SessionData.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    exercisesList: jspb.Message.toObjectList(msg.getExercisesList(),
    proto.gameapp.Exercise.toObject, includeInstance),
    currentExerciseIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.SessionData}
 */
proto.gameapp.SessionData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.SessionData;
  return proto.gameapp.SessionData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.SessionData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.SessionData}
 */
proto.gameapp.SessionData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = new proto.gameapp.Exercise;
      reader.readMessage(value,proto.gameapp.Exercise.deserializeBinaryFromReader);
      msg.addExercises(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCurrentExerciseIndex(value);
      break;
    case 4:
      var value = /** @type {!proto.gameapp.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.SessionData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.SessionData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.SessionData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.SessionData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExercisesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.gameapp.Exercise.serializeBinaryToWriter
    );
  }
  f = message.getCurrentExerciseIndex();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.gameapp.SessionData.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.SessionData} returns this
 */
proto.gameapp.SessionData.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Exercise exercises = 2;
 * @return {!Array<!proto.gameapp.Exercise>}
 */
proto.gameapp.SessionData.prototype.getExercisesList = function() {
  return /** @type{!Array<!proto.gameapp.Exercise>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gameapp.Exercise, 2));
};


/**
 * @param {!Array<!proto.gameapp.Exercise>} value
 * @return {!proto.gameapp.SessionData} returns this
*/
proto.gameapp.SessionData.prototype.setExercisesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.gameapp.Exercise=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gameapp.Exercise}
 */
proto.gameapp.SessionData.prototype.addExercises = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.gameapp.Exercise, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameapp.SessionData} returns this
 */
proto.gameapp.SessionData.prototype.clearExercisesList = function() {
  return this.setExercisesList([]);
};


/**
 * optional uint32 current_exercise_index = 3;
 * @return {number}
 */
proto.gameapp.SessionData.prototype.getCurrentExerciseIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.SessionData} returns this
 */
proto.gameapp.SessionData.prototype.setCurrentExerciseIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Status status = 4;
 * @return {!proto.gameapp.Status}
 */
proto.gameapp.SessionData.prototype.getStatus = function() {
  return /** @type {!proto.gameapp.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.gameapp.Status} value
 * @return {!proto.gameapp.SessionData} returns this
 */
proto.gameapp.SessionData.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.ExerciseSetReport.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.ExerciseSetReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.ExerciseSetReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ExerciseSetReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    exerciseIndex: jspb.Message.getFieldWithDefault(msg, 1, 0),
    setIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
    exerciseSet: (f = msg.getExerciseSet()) && proto.gameapp.ExerciseSet.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.ExerciseSetReport}
 */
proto.gameapp.ExerciseSetReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.ExerciseSetReport;
  return proto.gameapp.ExerciseSetReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.ExerciseSetReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.ExerciseSetReport}
 */
proto.gameapp.ExerciseSetReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExerciseIndex(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSetIndex(value);
      break;
    case 3:
      var value = new proto.gameapp.ExerciseSet;
      reader.readMessage(value,proto.gameapp.ExerciseSet.deserializeBinaryFromReader);
      msg.setExerciseSet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.ExerciseSetReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.ExerciseSetReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.ExerciseSetReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ExerciseSetReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseIndex();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSetIndex();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getExerciseSet();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.gameapp.ExerciseSet.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 exercise_index = 1;
 * @return {number}
 */
proto.gameapp.ExerciseSetReport.prototype.getExerciseIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.ExerciseSetReport} returns this
 */
proto.gameapp.ExerciseSetReport.prototype.setExerciseIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 set_index = 2;
 * @return {number}
 */
proto.gameapp.ExerciseSetReport.prototype.getSetIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.ExerciseSetReport} returns this
 */
proto.gameapp.ExerciseSetReport.prototype.setSetIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ExerciseSet exercise_set = 3;
 * @return {?proto.gameapp.ExerciseSet}
 */
proto.gameapp.ExerciseSetReport.prototype.getExerciseSet = function() {
  return /** @type{?proto.gameapp.ExerciseSet} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.ExerciseSet, 3));
};


/**
 * @param {?proto.gameapp.ExerciseSet|undefined} value
 * @return {!proto.gameapp.ExerciseSetReport} returns this
*/
proto.gameapp.ExerciseSetReport.prototype.setExerciseSet = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ExerciseSetReport} returns this
 */
proto.gameapp.ExerciseSetReport.prototype.clearExerciseSet = function() {
  return this.setExerciseSet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ExerciseSetReport.prototype.hasExerciseSet = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.AudioListenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.AudioListenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.AudioListenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.AudioListenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    prompt: jspb.Message.getFieldWithDefault(msg, 2, ""),
    seconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.AudioListenRequest}
 */
proto.gameapp.AudioListenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.AudioListenRequest;
  return proto.gameapp.AudioListenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.AudioListenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.AudioListenRequest}
 */
proto.gameapp.AudioListenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.AudioListenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.AudioListenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.AudioListenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.AudioListenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSeconds();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.gameapp.AudioListenRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.AudioListenRequest} returns this
 */
proto.gameapp.AudioListenRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string prompt = 2;
 * @return {string}
 */
proto.gameapp.AudioListenRequest.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.AudioListenRequest} returns this
 */
proto.gameapp.AudioListenRequest.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional float seconds = 3;
 * @return {number}
 */
proto.gameapp.AudioListenRequest.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.gameapp.AudioListenRequest} returns this
 */
proto.gameapp.AudioListenRequest.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.AudioListenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.AudioListenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.AudioListenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.AudioListenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    error: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.AudioListenResponse}
 */
proto.gameapp.AudioListenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.AudioListenResponse;
  return proto.gameapp.AudioListenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.AudioListenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.AudioListenResponse}
 */
proto.gameapp.AudioListenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.AudioListenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.AudioListenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.AudioListenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.AudioListenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.gameapp.AudioListenResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.AudioListenResponse} returns this
 */
proto.gameapp.AudioListenResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.gameapp.AudioListenResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.gameapp.AudioListenResponse} returns this
 */
proto.gameapp.AudioListenResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string error = 3;
 * @return {string}
 */
proto.gameapp.AudioListenResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.AudioListenResponse} returns this
 */
proto.gameapp.AudioListenResponse.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.ImageEvaluateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.ImageEvaluateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.ImageEvaluateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ImageEvaluateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    prompt: jspb.Message.getFieldWithDefault(msg, 2, ""),
    imageMimetype: jspb.Message.getFieldWithDefault(msg, 3, ""),
    image: msg.getImage_asB64(),
    responseType: jspb.Message.getFieldWithDefault(msg, 5, ""),
    model: jspb.Message.getFieldWithDefault(msg, 6, ""),
    detail: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.ImageEvaluateRequest}
 */
proto.gameapp.ImageEvaluateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.ImageEvaluateRequest;
  return proto.gameapp.ImageEvaluateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.ImageEvaluateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.ImageEvaluateRequest}
 */
proto.gameapp.ImageEvaluateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageMimetype(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setImage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.ImageEvaluateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.ImageEvaluateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.ImageEvaluateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ImageEvaluateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getImageMimetype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getImage_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getResponseType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ImageEvaluateRequest} returns this
 */
proto.gameapp.ImageEvaluateRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string prompt = 2;
 * @return {string}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ImageEvaluateRequest} returns this
 */
proto.gameapp.ImageEvaluateRequest.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string image_mimetype = 3;
 * @return {string}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getImageMimetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ImageEvaluateRequest} returns this
 */
proto.gameapp.ImageEvaluateRequest.prototype.setImageMimetype = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes image = 4;
 * @return {!(string|Uint8Array)}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getImage = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes image = 4;
 * This is a type-conversion wrapper around `getImage()`
 * @return {string}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getImage_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getImage()));
};


/**
 * optional bytes image = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImage()`
 * @return {!Uint8Array}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getImage_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getImage()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.gameapp.ImageEvaluateRequest} returns this
 */
proto.gameapp.ImageEvaluateRequest.prototype.setImage = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional string response_type = 5;
 * @return {string}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getResponseType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ImageEvaluateRequest} returns this
 */
proto.gameapp.ImageEvaluateRequest.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string model = 6;
 * @return {string}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ImageEvaluateRequest} returns this
 */
proto.gameapp.ImageEvaluateRequest.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string detail = 7;
 * @return {string}
 */
proto.gameapp.ImageEvaluateRequest.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ImageEvaluateRequest} returns this
 */
proto.gameapp.ImageEvaluateRequest.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.ImageEvaluateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.ImageEvaluateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.ImageEvaluateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ImageEvaluateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responseValue: (f = msg.getResponseValue()) && proto.gameapp.ValUnion.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.ImageEvaluateResponse}
 */
proto.gameapp.ImageEvaluateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.ImageEvaluateResponse;
  return proto.gameapp.ImageEvaluateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.ImageEvaluateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.ImageEvaluateResponse}
 */
proto.gameapp.ImageEvaluateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 3:
      var value = new proto.gameapp.ValUnion;
      reader.readMessage(value,proto.gameapp.ValUnion.deserializeBinaryFromReader);
      msg.setResponseValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.ImageEvaluateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.ImageEvaluateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.ImageEvaluateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ImageEvaluateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponseValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.gameapp.ValUnion.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.gameapp.ImageEvaluateResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ImageEvaluateResponse} returns this
 */
proto.gameapp.ImageEvaluateResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.gameapp.ImageEvaluateResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ImageEvaluateResponse} returns this
 */
proto.gameapp.ImageEvaluateResponse.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ValUnion response_value = 3;
 * @return {?proto.gameapp.ValUnion}
 */
proto.gameapp.ImageEvaluateResponse.prototype.getResponseValue = function() {
  return /** @type{?proto.gameapp.ValUnion} */ (
    jspb.Message.getWrapperField(this, proto.gameapp.ValUnion, 3));
};


/**
 * @param {?proto.gameapp.ValUnion|undefined} value
 * @return {!proto.gameapp.ImageEvaluateResponse} returns this
*/
proto.gameapp.ImageEvaluateResponse.prototype.setResponseValue = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameapp.ImageEvaluateResponse} returns this
 */
proto.gameapp.ImageEvaluateResponse.prototype.clearResponseValue = function() {
  return this.setResponseValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameapp.ImageEvaluateResponse.prototype.hasResponseValue = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameapp.ActivityInvoke.prototype.toObject = function(opt_includeInstance) {
  return proto.gameapp.ActivityInvoke.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameapp.ActivityInvoke} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ActivityInvoke.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameapp.ActivityInvoke}
 */
proto.gameapp.ActivityInvoke.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameapp.ActivityInvoke;
  return proto.gameapp.ActivityInvoke.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameapp.ActivityInvoke} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameapp.ActivityInvoke}
 */
proto.gameapp.ActivityInvoke.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameapp.ActivityInvoke.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameapp.ActivityInvoke.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameapp.ActivityInvoke} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameapp.ActivityInvoke.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string activity_id = 1;
 * @return {string}
 */
proto.gameapp.ActivityInvoke.prototype.getActivityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameapp.ActivityInvoke} returns this
 */
proto.gameapp.ActivityInvoke.prototype.setActivityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.gameapp.Status = {
  NOTSTARTED: 0,
  INPROGRESS: 1,
  COMPLETED: 2
};

goog.object.extend(exports, proto.gameapp);
